module.exports = __webpack_public_path__ + "45df3f36136bff09772ce3823fd4efc7.png";